import { useEffect, useState } from "react";
import {
  fetchAllActiveUsersNonPaginated,
  fetchAllBundlesNonPaginated,
  fetchAllCoursesNonPaginated,
  fetchAllGroupsNonPaginated,
} from "../../service/AdminService/enrollmentService";

const useEnrollmentData = () => {
  const [data, setData] = useState({
    users: [],
    courses: [],
    groups: [],
    bundles: [],
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAllData = async () => {
    try {
      setLoading(true);

      const [usersRes, groupsRes, bundlesRes, coursesRes] = await Promise.all([
        fetchAllActiveUsersNonPaginated(),
        fetchAllGroupsNonPaginated(),
        fetchAllBundlesNonPaginated(),
        fetchAllCoursesNonPaginated(),
      ]);

      setData({
        users: usersRes?.success ? usersRes.data : [],
        courses: coursesRes?.success ? coursesRes.data : [],
        groups: groupsRes?.success ? groupsRes.data : [],
        bundles: bundlesRes?.success ? bundlesRes.data : [],
      });
    } catch (err) {
      console.error("Error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  console.log({ data });

  return {
    ...data,
    loading,
    error,
    refetch: fetchAllData,
  };
};

export default useEnrollmentData;
